import React, { Component, Fragment } from "react";
// import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";

// Components:
import SpanE from "./SpanE.tsx";
import DivE from "./DivE.tsx";
import AppIcons from "./AppIcons.tsx";

// ===================================================

interface FlexibleModalPropTypes {
  modalKey:string;
  title?:string;
  icon?:React.ReactNode;
	top?: number;
	left?: number;
	initHeight?: number | "fit-content";
	initWidth?: number;
	minWidth?: number;
	minHeight?: number;
	isOpen: boolean;
  isClosableMask?:boolean;
  isDisableCloseButton?:boolean;
  isHiddenCloseButton?:boolean;
  closeOnEsc?:boolean;
  hasResizeable?:boolean;
  hasMoveable?:boolean;
  keysMovable?:boolean;
  hasMaximize?:boolean;
  zIndex?:number;
	className?: string;
  style?:React.CSSProperties;
	isMinimised?: boolean;
  isMaximize?:boolean;
	disableKeystroke?: boolean;
	onRequestClose: () => void;
	onRequestMinimise?: () => void;
	onRequestRecover?: () => void;
	onFocus?: () => void;
	onExpandWindow?: () => void;
	children?: React.ReactNode;
  dct:{[key:string]:any};
}

interface FlexibleModalStateTypes {
	width: number;
	height: number | "fit-content";
	top: number;
	left: number;
	rel?: {x:number; y:number, mouseX:number, mouseY:number};
	isDragging: boolean;
	isResizing: boolean;
	isMaximize: boolean;
	isExpanding: boolean;
}

// ================ Resizer ================

interface ResizerPropTypes {
  updateStateResizing: (v: boolean) => void;
}

class Resizer extends React.Component<ResizerPropTypes> {
  constructor(props: Readonly<ResizerPropTypes>) {
    super(props);
    this.handleMouseDown = this.handleMouseDown.bind(this);
  }

  handleMouseDown() {
    this.props.updateStateResizing(true);
  }

  render() {
    return (
      <div className="modal-resizer" style={{width: 16, height: 16}} onMouseDown={this.handleMouseDown} onTouchStart={this.handleMouseDown} />
    );
  }
}

// const clickEvent = new MouseEvent("click", { view: window, bubbles: true, cancelable: false });

// ================ Modal Functionality ================

interface ModalPropTypes {
  id?:string;
  className?:string;
  style?:React.CSSProperties;
  width?:number;
  height?:number | "fit-content";
  top?:number;
  left?:number;
  isDragging?:boolean;
  isOpen:boolean;
  isMinimised:boolean;
  onRequestRecover?:() => void;
  onFocus?:() => void;
  children?:React.ReactNode;
}

class Modal extends Component<ModalPropTypes> {
  node?:HTMLDivElement | null;

  render() {
    const { id, isDragging, style, width, height, top, left, isOpen, isMinimised, className, children, onFocus, onRequestRecover } = this.props;

    if (isOpen) {
      return (
        <Fragment>
          <CSSTransition in={!isMinimised} timeout={300} classNames="minimise" unmountOnExit>
            <div id={id}
              onClick={onFocus}
              ref={(node) => { this.node = node }}
              draggable={isDragging}
              className={className || ""}
              style={{...style, width, height, top, left }}
            >
              {children}
            </div>
          </CSSTransition>
          {isMinimised && (
            <button className="flexible-modal-rebound-btn" onClick={onRequestRecover}>
              <AppIcons icopath="fa/FaBars" attrs={{}} />
            </button>
          )}
        </Fragment>
      );
    }
    return null;
  }
}

// ================ Main conponent - Flexible Modal ================

class FlexibleModal extends Component<FlexibleModalPropTypes, FlexibleModalStateTypes> {
  node_modal?: Modal | null;

  dragArea?: HTMLDivElement | null;

  constructor(props: Readonly<FlexibleModalPropTypes>) {
    super(props);
    this.state = {
      isDragging: false,
      isResizing: false,
      isExpanding: false,
      top: (this.props.top !== undefined ? this.props.top : (typeof this.props.initHeight === "number" ? (window.innerHeight / 2) - (this.props.initHeight / 2) - 10 : (window.innerHeight / 2) - 150)),
      left: (this.props.left !== undefined ? this.props.left : (this.props.initWidth ? (window.innerWidth / 2) - (this.props.initWidth / 2) - 10 : (window.innerWidth / 2) - 400)),
      width: (this.props.initWidth ? this.props.initWidth : 800),
      height: (this.props.initHeight !== undefined ? this.props.initHeight : 400),
      isMaximize: Boolean(this.props.isMaximize)
    };
    this.updateStateResizing = this.updateStateResizing.bind(this);
    this.funcResizing = this.funcResizing.bind(this);
    this.funcMoving = this.funcMoving.bind(this);
    this.resize = this.resize.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.getTouches = this.getTouches.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.pressKey = this.pressKey.bind(this);

    this.closeButtonClick = this.closeButtonClick.bind(this);
    this.expandButtonClick = this.expandButtonClick.bind(this);
    this.checkAndSetValidSizeAndPosition = this.checkAndSetValidSizeAndPosition.bind(this);
  }

  componentDidMount() {
    const { disableKeystroke } = this.props;
    document.addEventListener("mouseup", this.onMouseUp);
    document.addEventListener("touchend", this.onTouchEnd);
    if (!disableKeystroke) { document.addEventListener("keyup", this.pressKey) }
  }

  componentWillUnmount() {
    const { disableKeystroke } = this.props;
    if (document.removeEventListener) {
      document.removeEventListener("mousemove", this.onMouseMove);
      document.removeEventListener("mouseup", this.onMouseUp);
      document.removeEventListener("touchmove", this.onTouchMove);
      document.removeEventListener("touchend", this.onTouchEnd);
      if (!disableKeystroke) { document.removeEventListener("keyup", this.pressKey) }
    }
  }

  onMouseDown(e: {button:number, pageX:number, pageY:number, stopPropagation:() => void, preventDefault:() => void}) {
    // only left mouse button
    document.addEventListener("mousemove", this.onMouseMove);
    if (e.button !== 0) return;
    // eslint-disable-next-line react/no-find-dom-node
    const node = this.node_modal?.node; // ReactDOM.findDOMNode(this.node_modal) as HTMLElement; // this.node_modal;
    if (node) {
      // @ts-ignore
      this.setState({isDragging: true, rel: {x: e.pageX - node.offsetLeft, y: e.pageY - node.offsetTop, mouseX: e.pageX, mouseY: e.pageY}});
    }
    e.stopPropagation(); e.preventDefault();
  }

  onMouseUp(e: { stopPropagation: () => void; }) {
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("touchmove", this.onTouchMove);
    this.setState({ isDragging: false, isResizing: false });
    e.stopPropagation();
    // e.preventDefault();
  }

  onMouseMove(e:{pageY:number; pageX:number; clientX:any; clientY:any; stopPropagation:() => void; preventDefault:() => void;}) {
    const { rel, isResizing, isDragging, isMaximize } = this.state;
    if (isMaximize || (!isDragging && !isResizing)) { return }
    e.stopPropagation(); e.preventDefault();
    if (isResizing) { this.funcResizing(e.clientX, e.clientY) }
    else if (isDragging && rel) { this.funcMoving(e.pageX, e.pageY, rel.x, rel.y, rel.mouseX, rel.mouseY) }
  }

  // eslint-disable-next-line class-methods-use-this
  getTouches(event) {
    return (event.changedTouches[0]
      ? event.changedTouches[0]
      : event.originalEvent && event.originalEvent.changedTouches[0]
        ? event.originalEvent.changedTouches[0]
        : null);
  }

  onTouchStart(e) {
    if (e.type !== "touchstart") { return }
    const touch = this.getTouches(e); if (!touch) { return }
    // only left mouse button
    document.addEventListener("touchmove", this.onTouchMove);
    // eslint-disable-next-line react/no-find-dom-node
    const node = this.node_modal?.node; // ReactDOM.findDOMNode(this.node_modal) as HTMLElement; // this.node_modal;
    if (node) {
      // @ts-ignore
      this.setState({isDragging: true, rel: {x: touch.pageX - node.offsetLeft, y: touch.pageY - node.offsetTop, mouseX: touch.pageX, mouseY: touch.pageY}});
    }
    if (e.event) { e.event.stopImmediatePropagation() }
  }

  onTouchMove(e) {
    const { rel, isResizing, isDragging, isMaximize } = this.state;
    if (e.type !== "touchmove" || isMaximize || (!isDragging && !isResizing)) { return }
    const touch = this.getTouches(e); if (!touch) { return }
    if (e.event) { e.event.stopImmediatePropagation() }
    if (isResizing) { this.funcResizing(touch.clientX, touch.clientY) }
    else if (isDragging && rel) { this.funcMoving(touch.pageX, touch.pageY, rel.x, rel.y, rel.mouseX, rel.mouseY) }
  }

  onTouchEnd(e) {
    if (e.type !== "touchend") { return }
    const touch = this.getTouches(e); if (!touch) { return }
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("touchmove", this.onTouchMove);
    this.setState({ isDragging: false, isResizing: false });
    if (e.event) { e.event.stopImmediatePropagation() }
  }

  updateStateResizing(isResizing:boolean) {
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("touchmove", this.onTouchMove);
    this.setState({ isResizing });
  }

  funcResizing(clientX:number, clientY:number) {
    // eslint-disable-next-line react/no-find-dom-node
    const node = this.node_modal?.node; // ReactDOM.findDOMNode(this.node_modal) as HTMLElement; // this.node_modal;
    const { minWidth, minHeight, hasResizeable } = this.props;
    const paddings = 16;
    if (this.state.isMaximize || !hasResizeable || !node) { return }
    const minWidthStrict = minWidth || 200, minHeightStrict = minHeight || 100;
    if (clientX > (node.offsetLeft + minWidthStrict) && clientX < window.innerWidth) {
      this.setState({width: clientX - node.offsetLeft + (paddings / 2)});
    }
    if (clientY > (node.offsetTop + minHeightStrict) && clientY < window.innerHeight) {
      this.setState({height: clientY - node.offsetTop + (paddings / 2)});
    }
    setTimeout(() => { this.checkAndSetValidSizeAndPosition("resize") }, 100);
  }

  funcMoving(mouseX:number, mouseY:number, relX:number, relY:number, relMouseX:number, relMouseY:number) {
    // eslint-disable-next-line react/no-find-dom-node
    const node = this.node_modal?.node; // ReactDOM.findDOMNode(this.node_modal) as HTMLElement; // this.node_modal;
    const { hasMoveable } = this.props;
    if (this.state.isMaximize || !hasMoveable || !node) { return }
    const paddings = 16;
    const toRight = Boolean((mouseX - relMouseX) > 0), toLeft = Boolean((mouseX - relMouseX) < 0), toBottom = Boolean((mouseY - relMouseY) > 0), toTop = Boolean((mouseY - relMouseY) < 0);
    if (hasMoveable
      && (node.offsetTop > paddings || toBottom) && (node.offsetLeft > paddings || toRight)
      && (((node.offsetTop + node.offsetHeight) < (window.innerHeight - paddings)) || toTop)
      && (((node.offsetLeft + node.offsetWidth) < (window.innerWidth - paddings)) || toLeft)
    ) {
      this.setState({left: mouseX - relX, top: mouseY - relY});
      setTimeout(() => { this.checkAndSetValidSizeAndPosition("moving") }, 100);
    }
  }

  pressKey(e: { ctrlKey: any; keyCode: any; key: any; stopPropagation: () => void; preventDefault: () => void }) {
    // eslint-disable-next-line react/no-find-dom-node
    const node = this.node_modal?.node; // ReactDOM.findDOMNode(this.node_modal) as HTMLElement; // this.node_modal;
    if (this.state.isMaximize || !node || this.props.disableKeystroke) { return }
    const { hasResizeable, hasMoveable, minWidth, minHeight, isDisableCloseButton, isHiddenCloseButton, closeOnEsc, onRequestClose } = this.props;
    const minWidthStrict = minWidth || 200, minHeightStrict = minHeight || 100, paddings = 16;
    if (e.ctrlKey && hasResizeable) {
      switch (e.keyCode) {
        case 37: // Ctrl + Left
          if ((node.offsetWidth - paddings) >= minWidthStrict) { this.setState((prevState) => ({ width: prevState.width - paddings })) }
          break;
        case 38: // Ctrl + Up
          if ((node.offsetHeight - paddings) >= minHeightStrict) { this.setState((prevState) => ({ height: (typeof prevState.height === "number" ? (prevState.height - paddings) : (node.offsetHeight - paddings)) })) }
          break;
        case 39: // Ctrl + Right
          if ((node.offsetLeft + node.offsetWidth + paddings) <= (window.innerWidth - (paddings / 4))) { this.setState((prevState) => ({ width: prevState.width + paddings })) }
          break;
        case 40: // Ctrl + Down
          if ((node.offsetTop + node.offsetHeight + paddings) <= (window.innerHeight - (paddings / 4))) { this.setState((prevState) => ({ height: (typeof prevState.height === "number" ? (prevState.height + paddings) : (node.offsetHeight + paddings)) })) }
          break;
        default:
      }
      setTimeout(() => { this.checkAndSetValidSizeAndPosition("resize") }, 100);
    } else if (hasMoveable) {
      switch (e.keyCode) {
        case 27: // Esc
          if (!isDisableCloseButton && !isHiddenCloseButton && closeOnEsc) { onRequestClose(); return }
          break;
        case 37: // Left
          if (this.props.keysMovable && (node.offsetLeft - paddings) >= paddings) { this.setState((prevState) => ({ left: prevState.left - paddings })) }
          break;
        case 38: // Up
          if (this.props.keysMovable && (node.offsetTop - paddings) >= paddings) { this.setState((prevState) => ({ top: prevState.top - paddings })) }
          break;
        case 39: // Right
          if (this.props.keysMovable && (node.offsetLeft + node.offsetWidth + paddings) <= (window.innerWidth - (paddings / 4))) { this.setState((prevState) => ({ left: prevState.left + paddings })) }
          break;
        case 40: // Down
          if (this.props.keysMovable && (node.offsetTop + node.offsetHeight + paddings) <= (window.innerHeight - (paddings / 4))) { this.setState((prevState) => ({ top: prevState.top + paddings })) }
          break;
        default:
      }
      setTimeout(() => { this.checkAndSetValidSizeAndPosition("moving") }, 100);
    }
  }

  resize(width: any, height: any) {
    this.setState((prevState) => ({ width: width || prevState.width, height: height || prevState.height }));
  }

  closeButtonClick(e) {
    e.stopPropagation(); e.preventDefault();
    this.props.onRequestClose();
  }

  expandButtonClick(e) {
    e.stopPropagation(); e.preventDefault();
    this.setState({isExpanding: true});
    if (this.props.onExpandWindow) this.props.onExpandWindow();
    this.setState((prevState) => ({ isMaximize: !prevState.isMaximize }));
    setTimeout(() => { this.setState({isExpanding: false}) }, 300);
  }

  checkAndSetValidSizeAndPosition(lastCommand:"resize" | "moving") {
    // eslint-disable-next-line react/no-find-dom-node
    const node = this.node_modal?.node; // ReactDOM.findDOMNode(this.node_modal) as HTMLElement; // this.node_modal;
    if (this.state.isMaximize || !node) { return }
    const minWidthStrict = this.props.minWidth || 200, minHeightStrict = this.props.minHeight || 100, paddings = 16;
    // Chech
    if (lastCommand === "resize") {
      if ((node.offsetLeft + node.offsetWidth) > (window.innerWidth - paddings)) {
        this.setState({ width: ((window.innerWidth - node.offsetLeft - paddings) < minWidthStrict ? minWidthStrict : (window.innerWidth - node.offsetLeft - paddings)) });
      }
      if ((node.offsetTop + node.offsetHeight) > (window.innerHeight - paddings)) {
        this.setState({ height: ((window.innerHeight - node.offsetTop - paddings) < minHeightStrict ? minHeightStrict : (window.innerHeight - node.offsetTop - paddings)) });
      }
    }
    else if (lastCommand === "moving") {
      if (node.offsetLeft < paddings) { this.setState({left: paddings}) }
      if (node.offsetTop < paddings) { this.setState({top: paddings}) }
      if ((node.offsetLeft + node.offsetWidth) > (window.innerWidth - paddings)) { this.setState({left: (window.innerWidth - node.offsetWidth - paddings)}) }
      if ((node.offsetTop + node.offsetHeight) > (window.innerHeight - paddings)) { this.setState({top: (window.innerHeight - node.offsetHeight - paddings)}) }
    }
  }

  render() {
    const {
      modalKey, title, icon, isOpen, isClosableMask, isMinimised, hasMoveable, hasResizeable, isDisableCloseButton, isHiddenCloseButton,
      className, style, children, dct, zIndex, onFocus, onRequestRecover, onRequestClose
    } = this.props;

    const { isMaximize, isResizing, isDragging, isExpanding, width, height, top, left } = this.state;

    return (
			<div>
        <style>
          {":root{--" + modalKey + "-height: " + (isMaximize ? "100vh;" : height + "px;") + " --" + modalKey + "-width: " + (isMaximize ? "100vw;" : width + "px;") + "}"}
        </style>
				{/* this mask is a must */}
				{isOpen && !isMinimised && (
          <a className="overlay-link" data-close="" onClick={(e) => { if (isClosableMask) { this.closeButtonClick(e) } }}>
            <div className="overlay" style={{zIndex: (zIndex && typeof zIndex === "number" && Number.isFinite(zIndex) ? (zIndex - 100) : 900)}} />
          </a>
				)}
				<Modal
          key={modalKey} id={modalKey}
					className={"modal-container"
            + (isOpen && !isMinimised ? " active" : " hide")
            + (isMaximize ? " maximize" : "")
            + (hasMoveable && !isMaximize ? " moveable" : "")
            + (hasResizeable && !isMaximize ? " resizable" : "")
            + ((!isDragging && !isResizing) || isExpanding ? " modal-transition-all" : "")
          }
					onFocus={onFocus}
					width={isMaximize ? undefined : width}
					height={isMaximize ? undefined : height}
					top={isMaximize ? undefined : top}
					left={isMaximize ? undefined : left}
					isDragging={isMaximize ? undefined : isDragging}
					onRequestRecover={onRequestRecover}
					isMinimised={Boolean(isMinimised)}
					isOpen={isOpen}
          style={{zIndex: (zIndex && typeof zIndex === "number" && Number.isFinite(zIndex) ? zIndex : 900)}}
					ref={(node) => { this.node_modal = node }}
				>
					<div key={modalKey + "-header"} id={modalKey + "-header"}
            className={"modal-header" + (isMaximize ? " maximize" : "") + (hasMoveable && !isMaximize ? " moveable" : "")}
						ref={(dragArea) => { this.dragArea = dragArea }}
						onMouseDown={this.onMouseDown} onTouchStart={this.onTouchStart}
					>
            <h3>
              <SpanE className="rz-txt-light" uk-tooltip={title || ""}>{icon}</SpanE>
              <SpanE className="rz-txt-light rz-margin-left-10 uk-overflow-hidden" uk-tooltip={title || ""}>{title || ""}</SpanE>
            </h3>
            <div className="modal-btn">
              <DivE className={"modal-header-buttons " + (!this.props.hasMaximize ? "modal-element-hidden" : "")}
                onClick={this.expandButtonClick} uk-tooltip={isMaximize ? dct.p.buttonCollapseWindow : dct.p.buttonExpandWindow}
              >
                {isMaximize
                  ? (<AppIcons icopath="fa/FaRegWindowRestore" className="modal-icons modal-icon-minimize" attrs={{}} />)
                  : (<AppIcons icopath="fa/FaRegWindowMaximize" className="modal-icons modal-icon-maximize" attrs={{}} />)
                }
              </DivE>
              <DivE data-close className={"modal-header-buttons" + (isDisableCloseButton ? " uk-disabled" : "") + (isHiddenCloseButton ? " uk-hidden" : "")}
                onClick={onRequestClose} uk-tooltip={dct.p.buttonclose}
              >
                <AppIcons icopath="md/MdClose" className="modal-icons modal-icon-close" attrs={{}} />
              </DivE>
            </div>
          </div>
          <div key={modalKey + "-body"} id={modalKey + "-body"} className={(className || "") + " modal-body"} style={style}>
            {children}
          </div>
					{hasResizeable && !isMaximize && <Resizer updateStateResizing={this.updateStateResizing} />}
				</Modal>
			</div>
    );
  }
}

export default FlexibleModal;
